// What the reader has chosen, mirrored in the URL hash so a view can be shared.
export var st = {
  view: 'now', farm: 'NF', tur: 'NF-07', h: 0, scenario: 'live', overlay: 'status', theme: 'dark',
  hwrt: false, curtailNeg: true, derate: false, playing: false, opt: null, booked: {},
  layers: { a: true, f: true, c: true, i: true, r: true }   // map: wind arrows, wind flow, clouds & rain & storm, fog & ice, roads
};

var KEYS = { v: 'view', f: 'farm', w: 'tur', h: 'h', s: 'scenario', o: 'overlay', th: 'theme' };

export function readHash(valid) {
  var h = (location.hash || '').replace(/^#/, ''); if (!h) return;
  h.split('&').forEach(function (kv) {
    var p = kv.split('='), k = p[0], v = decodeURIComponent(p[1] || '');
    if (KEYS[k] && valid(KEYS[k], v)) st[KEYS[k]] = KEYS[k] === 'h' ? +v : v;
    if (k === 'r') st.hwrt = v === '1';
    if (k === 'n') st.curtailNeg = v !== '0';
    if (k === 'd') st.derate = v === '1';
    if (k === 'l') Object.keys(st.layers).forEach(function (x) { st.layers[x] = v.indexOf(x) >= 0; });
  });
}

export function writeHash() {
  var p = ['v=' + st.view, 'f=' + st.farm, 'w=' + encodeURIComponent(st.tur)];
  if (st.h) p.push('h=' + st.h);
  if (st.scenario !== 'live') p.push('s=' + st.scenario);
  if (st.overlay !== 'status') p.push('o=' + st.overlay);
  if (st.theme !== 'dark') p.push('th=' + st.theme);
  if (st.hwrt) p.push('r=1');
  if (!st.curtailNeg) p.push('n=0');
  if (st.derate) p.push('d=1');
  var lay = Object.keys(st.layers).filter(function (x) { return st.layers[x]; }).join(''); if (lay !== 'afcir') p.push('l=' + (lay || '-'));
  try { history.replaceState(null, '', '#' + p.join('&')); } catch (e) {}
}
